export default __webpack_public_path__ + "static/media/gplMap.e991165a.jpg";